import styled from 'styled-components';

export const TransferIdentifier = styled.div`
  display: flex;
  align-items: center;
  flex-flow: wrap;
  gap: 0.25rem;
  margin: 0.5rem 0rem;
`;
